import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { AsaFormComponent } from './asa-form/asa-form.component';
import { CartComponent } from './cart/cart.component';
import { ViewComponent } from './view/view.component';
import { CompareComponent } from './compare/compare.component';
import { ChangeControlComponent } from './change-control/change-control.component';
import { AccessControlComponent } from './access-control/access-control.component';

const routes: Routes = [
  { path: 'view', canActivate: [MsalGuard], component: ViewComponent },
  { path: 'sync', canActivate: [MsalGuard], component: CompareComponent },
  { path: 'change', canActivate: [MsalGuard], component: ChangeControlComponent },
  { path: 'access', canActivate: [MsalGuard], component: AccessControlComponent },
  { path: 'asa-form', canActivate: [MsalGuard], component: AsaFormComponent },
  { path: '', redirectTo: '/view', pathMatch: 'full'},
  { path: '**', redirectTo: '/view'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, 
    {
      useHash: true,
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }